import { Popup, SpinLoading } from "antd-mobile";
import React, { useEffect, useRef, useState } from "react";
import styles from "./index.module.scss";
import { loadMain } from "../../../../components/AMapComp/loader";
import { CloseOutline } from "antd-mobile-icons";
import SelectItem from "../SelectItem";
import SearchBarWithButton from "../SearchBarWithButton";
import { getShopList } from "../../common/js/request";
import { calculateDistance } from "../../common/js/util";

interface Props {
  visible: boolean;
  setVisible: (v: boolean) => void;
  initValue?: any;
  onSuccess: (v: any) => void;
  position: {
    longitude: number;
    latitude: number;
  };
}

export const AddressSelectPopup = ({
  visible,
  setVisible,
  initValue,
  onSuccess,
  position,
}: Props) => {
  const [searchText, setSearchText] = useState("");
  const [list, setList] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [selectedStore, setSelectedStore] = useState<any>(initValue);
  const allListRef = useRef<any[]>([]);

  useEffect(() => {
    if (!visible || allListRef.current?.length) return;
    const startTime = new Date().getTime();
    async function onComplete(lat: any, lng: any) {
      // 获取门店列表
      const items = await getShopList({
        limit: 20,
        rescueLat: String(lat),
        rescueLon: String(lng),
      });

      items.forEach((item, index) => {
        // 根据起终点经纬度计算直线距离
        item.distance = calculateDistance(
          {
            longitude: lng,
            latitude: lat,
          },
          {
            longitude: item.locationLot,
            latitude: item.locationLat,
          },
        );
      });

      allListRef.current = items;
      console.log("总耗时:", new Date().getTime() - startTime);
      setLoading(false);
      setList(items);
      // 默认选中最近的门店
      setSelectedStore(items?.[0]);
    }

    // 基于待救援位置搜索
    if (position?.latitude && position?.longitude) {
      onComplete(position.latitude, position.longitude);
    } else {
      // 基于当前位置搜索
      const getCurrentPosition = async () => {
        await loadMain();
        AMap.plugin(["AMap.Geolocation"], function () {
          const geolocation = new AMap.Geolocation({
            enableHighAccuracy: true, //是否使用高精度定位，默认:true
            timeout: 10000, //超过10秒后停止定位，默认：5s
            buttonPosition: "RB", //定位按钮的停靠位置
            buttonOffset: new AMap.Pixel(10, 20), //定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
            zoomToAccuracy: true, //定位成功后是否自动调整地图视野到定位点
          });

          //解析定位错误信息
          function onError(data) {
            console.error(data.message);
          }

          geolocation.getCurrentPosition(function (status, result) {
            if (status === "complete") {
              const position = result.position;
              onComplete(position?.getLat(), position?.getLng());
            } else {
              onError(result);
            }
          });
        });
      };

      getCurrentPosition();
    }
  }, [visible, position]);

  const onClose = () => {
    setVisible(false);
    // 传递完整的门店信息，包括名称和距离
    if (selectedStore) {
      onSuccess({
        address: selectedStore.linkAddr,
        province: selectedStore.provinceName,
        city: selectedStore.cityName,
        district: selectedStore.areaName,
        locationLon: selectedStore.locationLot,
        locationLat: selectedStore.locationLat,
        trailerShopCode: selectedStore.shopCode,
        trailerShopName: selectedStore.fullName,
      });
    }
  };

  return (
    <Popup visible={visible} onMaskClick={onClose} destroyOnClose={false}>
      <div className={styles.popupContainer}>
        <div className={styles.header}>
          <div className={styles.title}>选择拖车目的地</div>
          <div className={styles.closeIcon} onClick={onClose}>
            <CloseOutline />
          </div>
        </div>
        <div className={styles.searchBarContainer}>
          <SearchBarWithButton
            value={searchText}
            onChange={(v) => {
              setSearchText(v);
              const filterList = allListRef.current.filter((item) =>
                item.fullName.includes(v),
              );
              setList(filterList);
            }}
            placeholder="搜索门店"
            showButton={true}
            onConfirm={onClose}
          />
        </div>
        <div className={styles.checkListContainer}>
          {loading ? (
            <SpinLoading style={{ "--size": "48px" }} />
          ) : (
            <div className={styles.storeList}>
              {list.map((item) => (
                <SelectItem
                  key={item.shopCode}
                  title={item.fullName}
                  selected={selectedStore.fullName === item.fullName}
                  distance={item.distance}
                  address={item.linkAddr}
                  onClick={() => {
                    setSelectedStore(item);
                  }}
                  highlightText={searchText}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </Popup>
  );
};
